import type { TFunction } from 'i18next';

export const getGoodsHeadings = (
  translate: TFunction
): {
  [key: string]: string;
} => ({
  doors: translate('calculator.dimensions.doorsWindows.goodsHeadings.doors'),
  windows: translate('calculator.dimensions.doorsWindows.goodsHeadings.windows'),
});
